import React from "react";
import { Col, ProgressBar } from "react-bootstrap";
import { t } from "i18next";
import { orderSpaceType } from "components/constants/DropdownOptions";
import Riyal from "assets/images/icons/darkRiyal.svg";

const OccupancyRateCard = ({ occupancy, index }) => {
  return (
    <Col xl={6} xxl={4} className="occupancy_card_wrapper">
      <div className="d-flex outer_dive">
        <h2 style={{ minWidth: 20 }} className={"fs_20"}>
          {String(index + 1)?.padStart(2, "0")}
        </h2>
        <div className="inner_section">
          <img
            src={occupancy?.imageUrl}
            alt=""
            className="h-100"
            width={100}
            height={100}
          />
          <div className="content">
            <div>
              <h3 className={"fs_14 text_black in_line_one"}>
                {occupancy?.name}
                {" - "}
                {t(
                  orderSpaceType?.find(
                    (option) => option.value === occupancy?.spaceTypeInt
                  )?.name
                )}
              </h3>
              <p className="fs_14 text_gray">
                {occupancy?.city}, {occupancy?.branch}
              </p>
            </div>

            <div className="d-flex justify-content-between gap-3">
              <div>
                <h2 className="fs_14 text_black mb-1">{t("Total Sales")}</h2>
                <h3 className="fs_14 text_gray d-flex gap-1">
                  <img src={Riyal} width={15} height={15} alt="riyal" />{" "}
                  {occupancy?.totalRevenue}
                </h3>
              </div>
              <div className="me-3">
                <h2 className="fs_14 text_black">Occupancy Rate</h2>
                <div className="w-100 custom_progressbar">
                  <ProgressBar
                    now={occupancy?.occupancyRate}
                    className="mt-2"
                  />
                  <span className="fs_14 text_primary">
                    {occupancy?.occupancyRate}%
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default OccupancyRateCard;
